import cn from "classnames";
import React from "react";
import GlobalNodesSvg from "../../../components/svgComponents/GlobalNodesSvg";
import GlobalFoundersItem from "./GlobalFoundersItem";
const GlobalFounders = ({
  rewardsDistributed,
  unclaimedXBR,
  claimXBRTotal,
  nodesLeft,
  hasNodes,
}) => {
  return (
    <section className="px-6 py-6 w-full dark:bg-[#1D1C2D] lg:dark:bg-transparent rounded-2xl">
      <div className="flex gap-[10px] mb-5">
        <div className="w-[38px] h-[38px] bg-iceBlue dark:bg-[#1D1C2D] dark:border dark:border-deepBlue  flex justify-center items-center rounded-lg">
          <GlobalNodesSvg />
        </div>
        <div>
          <p className="text-xs leading-[15px] text-semiBlack dark:text-semiWhite">
            Info about all XBR Nodes
          </p>
          <h2 className="text-black dark:text-white font-semibold text-xl leading-[24px] pt-[3px]">
            Global Founders
          </h2>
        </div>
      </div>
      <div
        className={cn("grid gap-5", {
          "md:grid-cols-2 lg:grid-cols-1": !hasNodes,
        })}
      >
        <GlobalFoundersItem itemLabel={"Global NODES"} itemValue={"5000"} />
        <GlobalFoundersItem
          itemLabel={"Rewards distributed"}
          itemValue={`${
            isNaN(parseFloat(rewardsDistributed).toFixed(2))
              ? parseFloat(0).toFixed(2)
              : parseFloat(rewardsDistributed).toFixed(2)
          } XBR`}
        />
        <GlobalFoundersItem
          itemLabel={"Unclaimed XBR"}
          itemValue={`${
            isNaN(parseFloat(unclaimedXBR).toFixed(2))
              ? parseFloat(0).toFixed(2)
              : parseFloat(unclaimedXBR).toFixed(2)
          } XBR`}
        />
        <GlobalFoundersItem
          itemLabel={"Claimed XBR"}
          itemValue={`${
            isNaN(parseFloat(claimXBRTotal).toFixed(2))
              ? parseFloat(0).toFixed(2)
              : parseFloat(claimXBRTotal).toFixed(2)
          } XBR`}
        />
        <GlobalFoundersItem
          itemLabel={"Available Founder's Node"}
          itemValue={isNaN(nodesLeft) ? 0 : nodesLeft}
        />
      </div>
    </section>
  );
};

export default GlobalFounders;
